import React from 'react';
import { Page } from '../Common/Components/Page';
import { UserManagementContent } from '../UserManagement/Components/UserManagementContent';

export const AreaUsers = (): React.JSX.Element => (
  <Page title="Users of Area" accessKey={'nodes'} isSearchable={true}>
    <UserManagementContent />
  </Page>
);
